import { FC } from 'react';
import Box from '@mui/material/Box';
import { getDateTime, getIsExpired } from '../lib/utils';
import { DataType } from '../model/types';
import { 
    CertificateCard, 
    CertificateInfo, 
    CertificateActions, 
    DenyButton, 
    ApproveButton, 
    CertificateText 
} from './styled';

const ContentTab: FC<{
    handleOpenModal: (id: number) => void;
    handleApprove: (id: number) => void;
    data?: DataType[];
}> = ({ handleOpenModal, handleApprove, data }) => (
    <Box display='flex' flexDirection='column' gap={1}>
        {data
            ?.sort((a, b) => {
                if (a.receivingDate > b.receivingDate) {
                    return 1;
                }
                if (a.receivingDate < b.receivingDate) {
                    return -1;
                }

                return 0;
            })
            .map(
                ({
                    id,
                    certificateKind,
                    recipientFullName,
                    status,
                    snils,
                    receivingDate,
                    declarant,
                    declarantType,
                    recipientBirthDate,
                    polis,
                    sanatoriumName
                }) => {
                    const {
                        lastName,
                        firstName,
                        middleName,
                        snils: declarantSnils,
                        documentPersonal: { nameDoc, serie, number, issuer, issueDate, codePodr },
                    } = declarant;

                    const declarantNameWithSnils =
                        lastName + ' ' + firstName + ' ' + middleName + ', снилс: ' + declarantSnils;

                    const declarantDocument =
                        nameDoc +
                        ': ' +
                        serie +
                        ' ' +
                        number +
                        ', выдан: ' +
                        issuer +
                        ' ' +
                        getDateTime(new Date(issueDate), true) +
                        ', код подразделения: ' +
                        codePodr;

                    const isExpired = getIsExpired(receivingDate);

                    return (
                        <CertificateCard
                            key={id}
                            className={isExpired ? 'expired' : ''}
                        >
                            <CertificateInfo>
                                <CertificateText variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
                                    {recipientFullName}
                                </CertificateText>
                                {recipientBirthDate && (
                                    <CertificateText>
                                        <strong>Дата рождения:</strong>{' '}
                                        {getDateTime(new Date(recipientBirthDate), true)}
                                    </CertificateText>
                                )}
                                <CertificateText>
                                    <strong>СНИЛС:</strong> {snils}
                                </CertificateText>
                                <CertificateText>
                                    <strong>Полис:</strong> {polis || '-'}
                                </CertificateText>
                                <CertificateText>
                                    <strong>Санаторий:</strong> {sanatoriumName || '-'}
                                </CertificateText>
                                <CertificateText sx={{ color: 'rgba(6, 182, 212, 0.8)', fontWeight: 500 }}>
                                    {certificateKind.name}
                                </CertificateText>
                                <CertificateText>
                                    <strong>Дата подачи:</strong> {getDateTime(new Date(receivingDate))}
                                </CertificateText>

                                <CertificateText>
                                    <strong>Заявитель:</strong> {declarantType.name}
                                </CertificateText>
                                <CertificateText>{declarantNameWithSnils}</CertificateText>
                                <CertificateText>{declarantDocument}</CertificateText>
                                <CertificateText>
                                    <strong>Статус:</strong> {status.name}
                                </CertificateText>
                            </CertificateInfo>
                            <CertificateActions>
                                <DenyButton onClick={() => handleOpenModal(id)}>
                                    Отказать
                                </DenyButton>
                                <ApproveButton onClick={() => handleApprove(id)}>
                                    Согласовать
                                </ApproveButton>
                            </CertificateActions>
                        </CertificateCard>
                    );
                },
            )}
    </Box>
);

export default ContentTab;
